'use client';

import { ReactNode } from 'react';

import { useSearchContext } from '@/src/services/search/SearchProvider';
import { useBrowseContext } from '@nxt-costco-com/forge-digital-components';

const CookieBasedContentLoaderWithLucidWorks = ({
    children,
    isSearchEnabled,
}: {
    children: ReactNode;
    isSearchEnabled: boolean;
}) => {
    const { thirdPartyInfo } = useBrowseContext();
    const { searchResult } = useSearchContext();
    const isWindowAvailable = typeof window !== 'undefined';
    const { consentManagement } = thirdPartyInfo || {};
    const { isTargetingEnabled } = consentManagement || {};
    const isAdTargetingEnabled =
        !isSearchEnabled || searchResult?.isAdTargetingEnabled;

    return (
        <>
            {isWindowAvailable &&
                isTargetingEnabled &&
                isAdTargetingEnabled &&
                children}
        </>
    );
};

export default CookieBasedContentLoaderWithLucidWorks;
